import styled from "styled-components";

export const Children = styled.div`
  position: -webkit-sticky; /* Safari */
  position: sticky;
  top: 0;
  display: flex;
  flex-direction: row;
  max-width: 100vw;
  height: 75vh;
  overflow-x: hidden;
  overflow-y: visible;
  align-items: center;
  justify-content: center;
`;
